import { Box, RadioGroup, Typography } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PaymentGroupsTypeIcon, PaymentIndividualsTypeIcon } from "../../../../../assets/icons/MUI/PaymentIcons";

import RecipientCard from "./RecipientCard";
import RecipientsOutsideGoalngoInput from "./RecipientsOutsideGoalngoInput";

const SelectRecipients = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", rowGap: "24px" }}>
      <Controller
        name="recipientsType"
        control={control}
        render={({ field }) => (
          <RadioGroup
            {...field}
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              columnGap: "24px",
            }}
          >
            <RecipientCard
              value="INDIVIDUALS"
              selectedValue={field.value}
              onChange={field.onChange}
              Icon={PaymentIndividualsTypeIcon}
              title={t("pages.payment.createPaymentLink.individuals")}
              description={t("pages.payment.createPaymentLink.sendPaymentLink")}
            />
            <RecipientCard
              value="GROUPS"
              selectedValue={field.value}
              onChange={field.onChange}
              Icon={PaymentGroupsTypeIcon}
              title={t("pages.payment.createPaymentLink.groups")}
              description={t("pages.payment.createPaymentLink.sendPaymentLinkToGroups")}
              disabled
              comingSoon
            />
          </RadioGroup>
        )}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          border: "1px solid #E7E7E7",
        }}
      >
        <Typography
          component="h6"
          sx={{
            color: "#111",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "24px",
            padding: "12px 16px",
            borderBottom: "1px solid #E7E7E7",
          }}
        >
          {t("pages.payment.createPaymentLink.sendToOthers")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "24px", padding: "16px" }}>
          <RecipientsOutsideGoalngoInput />
        </Box>
      </Box>
    </Box>
  );
};

export default SelectRecipients;
